import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "list-view" }
const _hoisted_2 = { class: "item__title" }
const _hoisted_3 = { class: "item__title--dimension" }
const _hoisted_4 = { class: "item__title--name" }
const _hoisted_5 = { class: "item__metric-type" }
const _hoisted_6 = { class: "item__table base-table-wrapper" }
const _hoisted_7 = { class: "item__table__header__inner" }

import { storeToRefs } from 'pinia';
import { useInventoryDashboardStore } from '../pages/useInventoryDashboardStore';
import EzTable from '@/corePagesModule/components/ezTable/EzTable.vue';
import { InventoryDashboardViewModel } from '../pages/inventoryDashboardViewModel';
import { i18n } from '@/i18n';
import EzTableRow from '@/corePagesModule/components/ezTable/EzTableRow.vue';
import EzCell from '@/corePagesModule/components/ezTable/EzCell.vue';
import RowCheckBox from '@/components/atom/RowCheckBox.vue';
import EzHeader from '@/corePagesModule/components/ezTable/EzHeader.vue';
import TextButton from '@/components/input/Btn/TextButton.vue';
import { UNASSIGNED_COLUMN } from '@/coreDomainsModule/constants';
import { MetricTypes } from '../domains/entities/Dashboard';
import { computed } from 'vue';
import { DashboardService } from '../domains/services/DashboardService';
import { HeaderList, isTableType } from '@/coreDomainsModule/table';
import { useTableHeader } from '@/corePagesModule/composables/useTableHeader';
import TableHeaderModifyButton from '@/corePagesModule/components/TableHeaderModifyButton.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'ListViewSection',
  setup(__props) {

const t = i18n.t;

const store = useInventoryDashboardStore();
const { state } = storeToRefs(store);
const {} = store;
const vm = new InventoryDashboardViewModel();

const isAggregateBusiness = computed(() => DashboardService.isMetricTypeByAggBiz(state.value.information.metricType));

const baseHeaderKeys = [
  { key: 'checkbox', width: 52 },
  { key: 'detail', width: 56 },
  { key: 'warehouseNumber', width: 160 },
  { key: 'warehouse', width: 160 },
  { key: 'supplierNumber', width: 160 },
  { key: 'supplierName', width: 160 },
  { key: 'businessNumber', width: 160 },
  { key: 'businessName', width: 160 },
  { key: 'package', width: 74 },
];

const aggregateBusinessBaseHeaderKeys = [
  { key: 'manufacturer', width: 160 },
  { key: 'aggregateBusinessResponsibleUsers', width: 160 },
];

const baseBusinessBaseHeaderKeys = [
  { key: 'customerNumber', width: 160 },
  { key: 'customerName', width: 160 },
  { key: 'salesDestinationNumber', width: 160 },
  { key: 'salesDestinationName', width: 160 },
  { key: 'endUser', width: 160 },
  { key: 'baseBusinessResponsibleUsers', width: 160 },
];

const customHeaderKeys = {
  [MetricTypes.Arrival]: [{ key: 'arrival', width: 128 }],
  [MetricTypes.CustomerForecast]: [{ key: 'customerForecast', width: 128 }],
  [MetricTypes.ForecastAccuracy]: [
    { key: 'salesResult', width: 128 },
    { key: 'customerForecast', width: 128 },
    { key: 'forecastAccuracy', width: 128 },
  ],
  [MetricTypes.Inventory]: [{ key: 'endInventory', width: 128 }],
  [MetricTypes.OrderAmount]: [{ key: 'orderAmount', width: 128 }],
  [MetricTypes.SalesResult]: [{ key: 'salesResult', width: 128 }],
  [MetricTypes.SupplierForecast]: [{ key: 'supplierForecast', width: 128 }],
  [MetricTypes.Turnover]: [
    { key: 'turnover', width: 128 },
    { key: 'salesResult', width: 128 },
    { key: 'customerForecast', width: 128 },
    { key: 'endInventory', width: 128 },
  ],
};

const fullHeaderOptions = computed(() => [
  ...baseHeaderKeys,
  ...(isAggregateBusiness.value ? aggregateBusinessBaseHeaderKeys : baseBusinessBaseHeaderKeys),
  ...customHeaderKeys[state.value.information.metricType],
  { key: 'headerModify', width: 57 },
]);
const fullHeaderKeys = computed(() => fullHeaderOptions.value.map((h) => h.key));
const tableType = computed(() => {
  const rawTableType =
    'inventoryDashboardByDimension' +
    state.value.information.metricType
      .toLowerCase()
      .split('_')
      .map((s) => s.charAt(0).toUpperCase() + s.slice(1))
      .join('');

  if (!isTableType(rawTableType)) {
    console.error(`Invalid table type: ${rawTableType}`);
    throw new Error(`Invalid table type: ${rawTableType}`);
  }
  return rawTableType;
});

const { headerList, updateDisplayHeader } = useTableHeader(fullHeaderKeys, tableType, []);
const modifiableHeaders = computed(
  (): HeaderList =>
    fullHeaderOptions.value
      .filter((h) => !['checkbox', 'detail', 'headerModify'].includes(h.key))
      .map((h) => ({
        key: h.key,
        text: vm.convertHeaderKeyToDisplayValue(h.key),
        isShown: headerList.value.includes(h.key),
      }))
);

const gridTemplateColumns = computed(() =>
  fullHeaderOptions.value.filter((header) => headerList.value.includes(header.key)).map((h) => `minmax(${h.width}px, ${h.width}fr)`)
);

/**
 * チェックされたかどうか
 * @param businessId - 対象の取引ID
 * @param isChecked - チェック済みかどうか
 */
const onCheckedRow = (businessId: string, isChecked: boolean) => {
  if (isChecked && !state.value.checkedBusinessId.includes(businessId)) {
    state.value.checkedBusinessId.push(businessId);
  } else if (!isChecked && state.value.checkedBusinessId.includes(businessId)) {
    state.value.checkedBusinessId = state.value.checkedBusinessId.filter((b) => b !== businessId);
  }
};

/**
 * ヘッダーを切り替える処理
 * @param headerKey - ヘッダーキー
 * @param isHide - 隠すかどうか
 */
const onToggleHeader = async (headerKey: string, isHide: boolean) => {
  await updateDisplayHeader(headerKey, isHide);
};

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).information.dimensionValueGroups, (dimensionValueGroup, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "item"
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)(_unref(vm).dimensionTypesMapper[_unref(state).information.dimensionType] ?? '')), 1),
          _createElementVNode("div", _hoisted_4, [
            (
              dimensionValueGroup.dimensionValues.name ||
              dimensionValueGroup.dimensionValues.value ||
              dimensionValueGroup.dimensionValues.unit
            )
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(dimensionValueGroup.dimensionValues.name) + " " + _toDisplayString(dimensionValueGroup.dimensionValues.value) + " " + _toDisplayString(dimensionValueGroup.dimensionValues.unit), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(_unref(t)(_unref(UNASSIGNED_COLUMN))), 1)
                ], 64))
          ])
        ]),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)(_unref(vm).metricTypesMapper[_unref(state).information.metricType] ?? '')), 1),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(EzTable, {
            "grid-template-columns": gridTemplateColumns.value,
            "sticky-header": "",
            "is-vertical-scrollable": ""
          }, {
            header: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(headerList).slice(0, -1), (header) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: header }, [
                  (header === 'checkbox')
                    ? (_openBlock(), _createBlock(EzHeader, {
                        key: 0,
                        class: "item__table__header"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(RowCheckBox)
                        ], undefined, true),
                        _: 1
                      }))
                    : (header === 'detail')
                      ? (_openBlock(), _createBlock(EzHeader, {
                          key: 1,
                          "content-padding": 0,
                          "force-center": "",
                          class: "item__table__header"
                        }))
                      : (_openBlock(), _createBlock(EzHeader, {
                          key: 2,
                          class: "item__table__header"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(vm).convertHeaderKeyToDisplayValue(header)), 1)
                          ], undefined, true),
                          _: 2
                        }, 1024))
                ], 64))
              }), 128)),
              _createVNode(EzHeader, { sticky: "right" }, {
                default: _withCtx(() => [
                  _createVNode(TableHeaderModifyButton, {
                    "modifiable-header-list": modifiableHeaders.value,
                    onToggle: onToggleHeader
                  }, null, 8, ["modifiable-header-list"])
                ], undefined, true),
                _: 1
              })
            ]),
            body: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dimensionValueGroup.businesses, (data, index1) => {
                return (_openBlock(), _createBlock(EzTableRow, {
                  key: index1,
                  "grid-template-columns": gridTemplateColumns.value
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(headerList).slice(0, -1), (header) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: header }, [
                        (header === 'checkbox')
                          ? (_openBlock(), _createBlock(EzCell, {
                              key: 0,
                              "is-highlighted": _unref(state).checkedBusinessId.includes(data.businessId),
                              class: "item__table__cell"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(RowCheckBox, {
                                  onChangeStatus: (isChecked) => onCheckedRow(data.businessId, isChecked)
                                }, null, 8, ["onChangeStatus"])
                              ], undefined, true),
                              _: 2
                            }, 1032, ["is-highlighted"]))
                          : (header === 'detail')
                            ? (_openBlock(), _createBlock(EzCell, {
                                key: 1,
                                "content-padding": 0,
                                "is-highlighted": _unref(state).checkedBusinessId.includes(data.businessId),
                                class: "item__table__cell"
                              }, {
                                default: _withCtx(() => [
                                  (data.businessId)
                                    ? (_openBlock(), _createBlock(_component_RouterLink, {
                                        key: 0,
                                        to: 
                      isAggregateBusiness.value
                        ? { name: 'recommend-order', params: { id: data.businessId } }
                        : { name: 'customer-forecast-timeline', params: { defaultBusinessId: data.businessId } }
                    ,
                                        target: "_blank"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(TextButton, {
                                            class: "table-detail-button",
                                            "button-style": "btn-secondary",
                                            "on-click": () => {}
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_unref(t)('詳細')), 1)
                                            ], undefined, true),
                                            _: 1
                                          })
                                        ], undefined, true),
                                        _: 2
                                      }, 1032, ["to"]))
                                    : _createCommentVNode("", true)
                                ], undefined, true),
                                _: 2
                              }, 1032, ["is-highlighted"]))
                            : (
                    ['aggregateBusinessResponsibleUsers', 'baseBusinessResponsibleUsers', 'forecastForReceiptResponsibleUsers'].includes(
                      header
                    )
                  )
                              ? (_openBlock(), _createBlock(EzCell, {
                                  key: 2,
                                  "is-highlighted": _unref(state).checkedBusinessId.includes(data.businessId),
                                  class: "item__table__cell"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(vm).convertUserAccountToDisplayValue(data[header])), 1)
                                  ], undefined, true),
                                  _: 2
                                }, 1032, ["is-highlighted"]))
                              : (_unref(vm).numberHeaderKeys.includes(header))
                                ? (_openBlock(), _createBlock(EzCell, {
                                    key: 3,
                                    "is-number": "",
                                    "is-highlighted": _unref(state).checkedBusinessId.includes(data.businessId),
                                    class: "item__table__cell"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_unref(vm).convertNumberStringToDisplayValue(header, data[header])), 1)
                                    ], undefined, true),
                                    _: 2
                                  }, 1032, ["is-highlighted"]))
                                : (_openBlock(), _createBlock(EzCell, {
                                    key: 4,
                                    "is-highlighted": _unref(state).checkedBusinessId.includes(data.businessId),
                                    class: "item__table__cell"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(data[header] ?? '--'), 1)
                                    ], undefined, true),
                                    _: 2
                                  }, 1032, ["is-highlighted"]))
                      ], 64))
                    }), 128)),
                    _createVNode(EzCell)
                  ], undefined, true),
                  _: 2
                }, 1032, ["grid-template-columns"]))
              }), 128))
            ]),
            _: 2
          }, 1032, ["grid-template-columns"])
        ])
      ]))
    }), 128))
  ]))
}
}

})